<template>
	<div>
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->
		<searchForm ref="MyTerm" @show="show" @handleSubmit="handleSubmit"></searchForm>
		<Table :columns="columns1" :data="data" :height="tableHeight" ref="tableData" size="small">
			<MyPage slot="footer" ref="sonPage" :param="SelectParam" :url="getCouponIssueUrl" @listData='getDeviceData'></MyPage>
		</Table>
		<infoModal @handleSubmit="handleSubmit" ref="ItemModal"></infoModal>
	</div>
</template>
<script>
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi';
	import searchForm from './Template/CouponForm.vue';
	import infoModal from './Template/CouponModal.vue';
	// import DistributeModal from './Template/DistributeModal.vue';
	export default {
		components: {
			searchForm,
			infoModal,
			// DistributeModal
		},
		data() {
			return {
				getCouponIssueUrl: webapi.base_api_url + '/Operations/GetCouponIssue',
				//查询组件的参数
				SelectParam: {},
				loadingStatus: false,
				tableHeight: "650",
				BreadcrumbList: ['运营管理', '>>', '优惠券管理'],
				//table标题数据
				columns1: [
					// {
					// 	title: 'ID',
					// 	key: 'Id',
					// 	width: 100
					// }, 
					{
						title: '发行状态',
						key: 'IssueStatusDesc',
						minWidth: 100
					},
					{
						title: '优惠券类型',
						key: 'CouponType',
						minWidth: 100,
						render: (h, params) => {
							let typeDesc = ""
							switch (params.row.CouponType) {
								case 1:
									typeDesc = '满减金额(服务费)'
									break;
								case 2:
									typeDesc = '满减折扣(服务费)'
									break;
								case 3:
									typeDesc = '随机立减(服务费)'
									break;
								default:
									typeDesc = "未定义编码"
									break;
							}
							return h('div', typeDesc)
						}
					},
					{
						title: '优惠券名称',
						key: 'ConponName',
						minWidth: 120,
					},
					// {
					// 	title: '优惠券描述',
					// 	key: 'ConponDesc',
					// },
					{
						title: '发行数量',
						key: 'CouponNum',
						minWidth: 80,
					},
					{
						title: '剩余数量',
						key: 'RemainNum',
						minWidth: 80,
					},
					{
						title: '领取数量',
						key: 'GettedNum',
						minWidth: 80,
					},
					{
						title: '已用数量',
						key: 'UsedNum',
						minWidth: 80,
					},
					{
						title: '发行总金额(元)',
						key: 'CouponTotalAmount',
						minWidth: 80,
					},
					{
						title: '前提条件',
						key: 'RequireAmount',
						minWidth: 80,
						//width:100
					},
					{
						title: '优惠金额(元)',
						key: 'CouponAmount',
						minWidth: 80,
					},
					{
						title: '生效时间',
						key: 'StartTime',
						minWidth: 130,
					},
					{
						title: '优惠券失效时间',
						key: 'EndTime',
						minWidth: 130,
					},
					{
						title: '操作',
						key: 'action',
						align: 'center',
						minWidth: 180,
						render: (h, params) => {
							return h('div', [
								this.hasWidgets('view') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show('up', params.row)
										}
									}
								}, '查看') : h(),
								this.methodList.filter(item => this.hasWidgets(item.name)).length > 0 ? h('Dropdown', {
										on: {
											//为了不误操作，确定取消相反
											'on-click': (name) => {
												this.$Modal.confirm({
													title: name,
													okText: '取消',
													cancelText: '确定',
													onCancel: () => {
														this.otherMethod(name, params.row
															.IssueId);
													}
												});
												// this.show("deleteStation", params.row.Id)
											}
										}
									},
									[
										h('Button', {
											props: {
												type: 'primary',
												size: 'small',
											},
											style: {
												marginRight: '5px'
											},
										}, '其他操作'),
										h('DropdownMenu', {
											slot: 'list'
										}, [
											this.methodList.filter(item => this.hasWidgets(item.name)).map((
												item) => { // this.productTypeList下拉框里的data
												return h('DropdownItem', {
														props: {
															name: item.Status
														}
													},
													item.Status
												)
											})
										])
									],
								) : h()
							]);
						}
					}
				],
				data: [{}],
				methodList: [{
					Id: 1,
					name: 'issue',
					Status: '发行'
				}, {
					Id: 99,
					name: 'revoke',
					Status: '撤回'
				}]
			}
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 160;
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.SelectParam = this.$refs.MyTerm.formInline
			this.$nextTick(() => {
				this.handleSubmit();
			})
		},
		computed: {
			//直接选属性
			...mapState({
				StationList: 'Stations',
			})
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			otherMethod: function(name, Id) {
				let typeNum = (this.methodList.filter(function(item, index, arr) {
					return item.Status == name
				})[0]).Id
				this.$axios.post(webapi.base_api_url + "/Operations/SetCouponIssueStatus", {
					IssueId: Id,
					IssueStatus: typeNum
				}).then(res => {
					if (res.data.Code == 0) {
						this.$Message.info(name + '成功');
						this.handleSubmit();
					}
				})
			},

			/******************组件固定方法*************************/
			show: function(type, params) {
				this.$refs.ItemModal.show(type, params)
			},
			getDeviceData: function(data) {
				console.log(data)
				this.data = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.sonPage.getList();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 160;
			},
			exportFile: function() {
				this.$refs.tableData.exportCsv({
					filename: '优惠券',
					columns: this.columns1,
					data: this.data1.map(k => {
						k.OrderNo = "\t" + k.OrderNo;
						k.OrderTime = '\t' + (k.OrderTime || '');
						k.StartTime = '\t' + (k.StartTime || '');
						k.EndTime = '\t' + (k.EndTime || '');
						k.RefundTime = '\t' + (k.RefundTime || '');
						return k;
					})
				})
			}
		},
	}
</script>

<style>
</style>
